import { useState, useCallback, useEffect } from 'react'
import { api } from '../api/client.js'

export interface ApprovalLevel {
  id: string
  name: string
}

export interface UseApprovalLevelsResult {
  approvalLevels: ApprovalLevel[]
  loading: boolean
  error: string | null
  refetch: () => Promise<void>
}

export function useApprovalLevels(): UseApprovalLevelsResult {
  const [approvalLevels, setApprovalLevels] = useState<ApprovalLevel[]>([])
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState<string | null>(null)

  const refetch = useCallback(async (): Promise<void> => {
    setLoading(true)
    setError(null)
    try {
      const res = await api.get<{ approvalLevels: ApprovalLevel[] }>('/admin/conversation-management/approval-levels/dropdown')
      setApprovalLevels(res.approvalLevels || [])
    } catch (e) {
      setError(e instanceof Error ? e.message : 'Failed to fetch approval levels')
    } finally {
      setLoading(false)
    }
  }, [])

  useEffect(() => {
    void refetch()
  }, [refetch])

  return { approvalLevels, loading, error, refetch }
}
